import _ from 'lodash';
import api from '../../api';
import * as types from '../mutation-types';

const state = {
  items: {},
};

const getters = {
  getAmazonItemByItemCode: s => itemCode => _.get(s, ['items', itemCode]),
};

const actions = {
  fetchAmazonItem({ commit }, itemCode) {
    return api.amazon.getItem(itemCode).then(({ data: response }) => {
      commit(types.RECEIVE_AMAZON_ITEM, response);
    });
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.RECEIVE_AMAZON_ITEM](s, data) {
    const { ASIN } = data;
    s.items[ASIN] = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
